import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Funds from "../views/Funds.vue";
import Swimming from "../views/Swimming.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/inot",
    name: "Swimming",
    component: Swimming,
      meta: { scrollToTop: true, hideFooter: true }   // ← add this line

  },
  {
    path: "/transparenta",
    name: "Funds",
    component: Funds,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  { path: "*", redirect: "/" },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  // Scroll to top on every route change (or only when meta.scrollToTop is true)
  if (to.meta.scrollToTop) {
    window.scrollTo(0, 0)
  }
  next()
})

export default router;
